module.exports = __webpack_public_path__ + "static/media/image007.9b46a6c0.png";